module.exports = "/static/media/sendFax.f0061286.svg";